export interface Config {
    fontPath: string;
    appUrl: string;
    authUrl: string;
    liveBioDomain: string;
    siteHomePage: string;
    fbAppId: string;
    googleKey: string;
}

const config: Config = {
    fontPath: process.env.REACT_APP_FONT_PATH as string,
    appUrl: process.env.REACT_APP_ENDPOINT as string,
    authUrl: process.env.REACT_APP_AUTH_ENDPOINT as string,
    liveBioDomain: process.env.REACT_APP_LIVE_BIO_DOMAIN as string,
    siteHomePage: process.env.REACT_APP_SITE_HOME_PAGE as string,
    fbAppId: process.env.REACT_APP_FB_APP_ID as string,
    googleKey: process.env.REACT_APP_GOOGLE_KEY as string,
};

export default config;
